<template>
  <div id="app">
    <Headercomponent />
    <div class="backgroundanim">
      <img
        class="fixedship"
        v-bind:class="this.$route.name+'r'"
        src="./assets/images/fixed-ship-bg.svg"
      >
      <img
        class="backgroundimg"
        src="./assets/images/background.png"
        v-if="getBrowser()"
      >
      <img
        class="backgroundimg"
        src="./assets/images/background.svg"
        v-if="!getBrowser()"
      >
    </div>
    <router-view></router-view>
  </div>
</template>

<style>
/* https://daneden.github.io/animate.css/ */
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.css");
@import url("https://fonts.googleapis.com/css?family=PT+Sans+Narrow:400,700&subset=latin-ext");
@import url("https://fonts.googleapis.com/css?family=Abril+Fatface&subset=latin-ext");
@import url("./assets/ie.css");

#app {
  font-family: "PT Sans Narrow", Arial, sans-serif;
}
h1 {
  font-size: 65px;
  font-family: "Abril Fatface", cursive;
  font-weight: 400;
  margin: 0;
}
h2 {
  font-family: "Abril Fatface", cursive;
  font-size: 28px;
}
body {
  margin: 0;
  padding: 0;
  background-color: #72c2d2;
  color: #42475c;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}
.btn,
input[type="submit"] {
  cursor: pointer;
  background-color: #41465b;
  color: #fff;
  padding: 15px 30px;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 22px;
  border: none;
  width: fit-content;
}
.btn:focus,
.btn:active,
input[type="submit"]:focus,
input[type="submit"]:active {
  outline: none;
}
.btn:hover,
input[type="submit"]:hover {
  background-color: #4d546f;
}
.home,
.kviz {
  z-index: 1;
  position: relative;
}
.backgroundanim {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: calc(100vh - 65px);
  z-index: 0;
}
.backgroundimg {
  height: 90%;
  width: auto;
  transition: transform 1500ms linear;
  position: absolute;
  bottom: 0;
  left: 0;
}
.fixedship {
  position: absolute;
  z-index: 1;
  height: 22.01666%;
  transition: transform 1500ms linear;
  top: 58.2%;
  left: 22.1%;
  min-height: initial;
}
.fixedship.homer {
  transform: translateX(0%);
}
.fixedship.kvizr,
.fixedship.bevezetor {
  transform: translateX(-80%);
}
@media screen and (max-width: 1200px) {
  .fixedship {
    left: 16.5%;
  }
}
@media screen and (max-width: 1100px) {
  .fixedship.kvizr,
  .fixedship.bevezetor {
    transform: translateX(-92%);
  }
}
@media screen and (max-width: 767px) {
  .backgroundimg {
    height: 75%;
  }
  .fixedship {
    top: 64.2%;
    left: 20px;
  }
  .fixedship.kvizr,
  .fixedship.bevezetor {
    transform: translateX(-25%);
  }
  .btn,
  input[type="submit"] {
    font-size: 15px;
  }
}
@media screen and (max-width: 550px) {
  .backgroundimg {
    height: 60%;
  }
  .fixedship {
    top: 71.2%;
    left: 0px;
    height: 18.01666%;
  }
  .btn,
  input[type="submit"] {
    font-size: 17px;
  }
}
@media screen and (max-width: 450px) {
  .backgroundanim {
    height: calc(100vh - 93px);
  }
}
</style>

<script>
import Headercomponent from '@/components/Headercomp.vue'

export default {
  components: {
    Headercomponent
  },
  data: function () {
    return {
      bgNum: this.$store.state.bgCurrent
    }
  },
  methods: {
    getBrowser () {
      const browser = navigator.userAgent
      if (browser.indexOf('Firefox/66') > -1) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
